import React, { Component } from 'react';
import { connect } from 'react-redux';
import { notify } from '@mrlannigan/reapop';
import { get } from 'lodash';
import { USER_LOGGED_OUT } from 'constants/statusCodes';
import LoginForm from 'components/organisms/forms/Login';

class LoginFormContainer extends Component {
    render() {
        switch (this.props.query.status) {
        case undefined:
            break;
        case USER_LOGGED_OUT:
            this.props.notify({
                title: '',
                message: 'Logged out successfully',
                status: 'success',
                dismissible: true,
                dismissAfter: 2000
            });
            break;
        default:
            console.warn('Unknown status found: ', this.props.query.status); // eslint-disable-line no-console
        }

        return (
            <LoginForm hideSSO={this.props.isWhitelabel} />
        );
    }
}

const mapStateToProps = state => ({
    isWhitelabel: get(state, 'router.isWhitelabel', false),
    query: get(state, 'router.parsedUrl.query', {})
});

export default connect(mapStateToProps, { notify })(LoginFormContainer);



// WEBPACK FOOTER //
// ./src/containers/LoginFormContainer.js